<template>
    <div>

        <h2 style="margin:10px 0px 10px 0px;">Geofolio Pro Credits Available</h2>
        <p v-if="profile">
            You currently have <strong>{{ profile.credits.credits_available_count }}  credits available</strong> to use in your account.
        </p>
        <hr/>
        <h2 style="margin:10px 0px 10px 0px;">Add Credits</h2>
        <p>
            Credits can be used to unlock additional functionality for your areas of interest, such as advanced tools, data downloads, and extending the expiry date of your areas of interest. You can upgrade an individual factsheet from within the factsheet page itself.
        </p>
        <p>
            To purchase credits in bulk you can use the button below. The credits will be added to your account and can then be used to upgrade factsheets at any time.
        </p>



          <div class="row">
            <div class="col text-center">
                <div style="background-color:#f5f5f5;padding:15px;">
                    <a href="/credits/add/10" class="btn btn-primary" style="font-size:18px;margin:5px;margin-bottom:15px;"> Purchase <strong>10 Geofolio Pro credits for EUR 200</strong> <i class="bi bi-box-arrow-up-right" style="margin-left:12px;"></i></a>
                    <br/>
                    <span style="font-size:18px;font-weight:400;color:#888;">Clicking the button will redirect you to our payment provider</span>
                </div>
            </div>
           </div>

        <hr/>

        <div v-if="credits">

            <h2 style="margin:10px 0px 10px 0px;">Credits Received</h2>
            <p>
                Pending transactions are transactions which are in progress, but not completed yet. Once the transaction is completed, you will be able to spend the associated credits.
            </p>

            <table class="table table-sm table-bordered" style="color:#666;background-color:#fff;font-size:18px;">
                <tr style="">
                    <th>Date</th><th>Status</th><th class="text-center">Credits</th><th class="text-left">Transaction No.</th><th style="width:100%;">Details</th>
                </tr>
                <tr v-for="transaction in credits.credits_received">
                    <td><nobr>{{ transaction.created_at.substr(0,10) }}</nobr></td>
                    <td class="text-center">
                        <span v-if="transaction.status == 1">Ok</span>
                        <span v-else>Pending</span>
                    </td>
                    <td class="text-center">+{{ transaction.number_of_credits }}</td>
                    <td>{{ transaction.transaction_number }}</td>
                    <td>{{ transaction.message }}</td>
                </tr>
            </table>
                
        </div>


        <hr/>

        <div v-if="credits">

            <h2 style="margin:10px 0px 10px 0px;">Credits Spent</h2>
            <p>
                The following table shows which credits you have used, and when additional credits have been added to your account.
            </p>

            <table class="table table-bordered table-sm" style="color:#666;background-color:#fff;font-size:18px;">
                <tr style="">
                    <th>Date</th><th>Status</th><th class="text-center">Credits</th><th style="width:100%;">Details</th>
                </tr>
                <tr v-for="credit in credits.credits_spent">
                    <td><nobr>{{ credit.used_at.substr(0,10) }}</nobr></td>
                    <td class="text-center">Ok</td>
                    <td class="text-center">&ndash;1</td>
                    <td>{{ credit.message }}</td>
                </tr>
            </table>
                
        </div>


        <div style="padding:15px;background-color:#f5f5f5;" class="text-center">
        <a href="#" @click.prevent="refresh" style="font-size:18px;"><i class="bi bi-arrow-repeat"></i> Refresh credits overview</a>
        </div>

    </div>
</template>

<script>
  export default {
    name: 'account-credits',
    components: {
      
    },
    data() {
        return {
            credits: undefined
        }
    },
    mounted() {

    },
    created() {
        this.loadCredits();
    },
    computed: {
        profile() {
          return this.getProfile();
        },
    },
    methods: {
        loadCredits() {
            const headers = {
                Authorization: "Token " + this.apitoken(),
            };
            this.$axios
                .get(process.env.VUE_APP_API+"/api/credits", null, { headers: headers , validateStatus: () => true})
                .then(response => {

                    this.credits = response.data
                })
                .catch(error => {
                    console.log("An error occurred while loading credits.")
                })   
        },
        refresh() {
            this.updateprofile();
            this.loadCredits();
        }
    }
  }
</script>

<style scoped>
    h2 {
        font-size:24px;
    }
    table th {
        border-top:none;
        
    }
    table td {
        padding:5px 5px;
    }
    button {
        font-size:16px;
        font-weight:400;
    }
</style>


